export default {
    login_social: false,
    nombre:"",
    rut:"",
    correo:"",
    telefono:"",
    password:"",
    confirmar_password:"",
    direccion:"",
    coordenadas:"",
    valido: false,
    validacion:"",
    recuperar: false,
    id_facebook:"",
    tiempo_sesion: 0,
    nombre_vista:"",
    correo_valido: false,
    clear_form: false,
}